import cn from 'classnames'
import { ReactNode, useEffect } from 'react'

export const HandleDrawer = ({ drawerId, className, children }: { drawerId: string; className?: string; children: ReactNode }) => {
  const pageOverlay = document.getElementsByClassName('PageOverlay')[0]
  const drawer = document.getElementById(drawerId)
  const closeIcon = drawer?.querySelector('[data-action="close-drawer"]')

  const closeDrawer = () => {
    drawer?.setAttribute('aria-hidden', 'true')
    setTimeout(() => {
      pageOverlay.classList.remove('is-visible')
    }, 500)
  }

  const openDrawer = () => {
    drawer?.setAttribute('aria-hidden', 'false')
    pageOverlay?.classList.add('is-visible')
  }

  useEffect(() => {
    pageOverlay.addEventListener('click', closeDrawer)
    closeIcon?.addEventListener('click', closeDrawer)
  }, [])

  return (
    <button onClick={() => openDrawer()} className={cn('text-primary uppercase', className)}>
      {children}
    </button>
  )
}
